import { Action, createReducer, on } from '@ngrx/store'

import { ComponentModifier } from '@app/features/company-management/models/component-modifier.model'
import { scopeConfigurationInitialState } from '@app/features/scope-overview/const'
import { ScopeConfigurationState } from '@app/features/scope-overview/model/scope-configuration/scope-configuration.state.model'
import { ScopeConfigurationActions } from '@app/features/scope-overview/store/actions/scope-configuration.actions'
import { ScopeOverviewActions } from '@app/features/scope-overview/store/actions/scope-overview.action'

const submitConfigurationHandler = (state: ScopeConfigurationState) => ({
  ...state,
  loading: { ...state.loading, submitConfiguration: true },
})

const submitConfigurationSuccessHandler = (state: ScopeConfigurationState): ScopeConfigurationState => ({
  ...state,
  loading: { ...state.loading, submitConfiguration: false },
})

const submitConfigurationFailHandler = (state: ScopeConfigurationState, action: { error: Error }) => ({
  ...state,
  error: action.error,
  loading: { ...state.loading, submitConfiguration: false },
})

const getModifiersHandler = (state: ScopeConfigurationState) => ({
  ...state,
  loading: { ...state.loading, getModifiers: false },
})

const getModifiersSuccessHandler = (state: ScopeConfigurationState, action: { modifiers: ComponentModifier[] }) => ({
  ...state,
  modifiers: action.modifiers,
  loading: { ...state.loading, getModifiers: false },
})

const getModifiersFailHandler = (state: ScopeConfigurationState, action: { error: Error }) => ({
  ...state,
  error: action.error,
  loading: { ...state.loading, getModifiers: false },
})

const getConfigurationHandler = (state: ScopeConfigurationState, { currentScope }) => ({
  ...state,
  configuration: currentScope.configuration,
})

const saveConfigurationHandler = (state: ScopeConfigurationState) => ({
  ...state,
  loading: { ...state.loading, saveConfiguration: true },
})

const saveConfigurationSuccessHandler = (state: ScopeConfigurationState, { configuration }) => ({
  ...state,
  configuration,
  loading: { ...state.loading, saveConfiguration: false },
})

const saveConfigurationFailHandler = (state: ScopeConfigurationState, error) => ({
  ...state,
  error,
  loading: { ...state.loading, saveConfiguration: false },
})

const ScopeConfigurationReducer = createReducer(
  scopeConfigurationInitialState,
  on(ScopeConfigurationActions.submitForm, submitConfigurationHandler),
  on(ScopeConfigurationActions.submitConfigurationSuccess, submitConfigurationSuccessHandler),
  on(ScopeConfigurationActions.submitConfigurationFail, submitConfigurationFailHandler),
  on(ScopeConfigurationActions.getModifiers, getModifiersHandler),
  on(ScopeConfigurationActions.getModifiersSuccess, getModifiersSuccessHandler),
  on(ScopeConfigurationActions.getModifiersFail, getModifiersFailHandler),
  on(ScopeConfigurationActions.saveConfiguration, saveConfigurationHandler),
  on(ScopeConfigurationActions.saveConfigurationSuccess, saveConfigurationSuccessHandler),
  on(ScopeConfigurationActions.saveConfigurationFail, saveConfigurationFailHandler),
  on(ScopeOverviewActions.getCurrentScopeSuccess, getConfigurationHandler)
)

export function scopeConfigurationReducer(
  state: ScopeConfigurationState | undefined,
  action: Action
): ScopeConfigurationState {
  return ScopeConfigurationReducer(state, action)
}
